export default __webpack_public_path__ + "d14c47549c8307cca68daeff13eb82c1.png";